import * as types from '../actionType'

const initialState = []

export const userToSeller = (state = initialState, action) => {
    switch (action.type) {
        case types.CHAT_SELLER:
            return action.payload
        default:
            return state
    }
}